import dataTable from './dataTable.vue'
const _dataTable = {
    install:function(Vue){
        Vue.component('WtDataTable',dataTable)
    }
}
export default _dataTable


// WEBPACK FOOTER //
// ./src/components/dataTable/dataTable.js